/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Chat_Tool_Bulk_Trash_WarningInputs */



/**
* | output |
* | --- |
* | "Moves to the trash — restorable for {days} days. Review before approving." |
*
* @param {Chat_Tool_Bulk_Trash_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_trash_warning = /** @type {((inputs: Chat_Tool_Bulk_Trash_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Trash_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verschiebt in den Papierkorb — ${i?.days} Tage wiederherstellbar. Vor dem Genehmigen prüfen.`)
	return /** @type {LocalizedString} */ (`Moves to the trash — restorable for ${i?.days} days. Review before approving.`)
});